window.autoCompleteSearchBar = null;
window.initAutoComplete = (input) => {
  try{
    const options = {
      componentRestrictions: { country: 'can' }
    };

    window.google && new window.google.maps.places.Autocomplete(window.autoCompleteSearchBar || input, options);
    // autocomplete && autocomplete.setFields([, "name"]);
  }catch (e) {
    console.log('error', e);
  }
};
export default function locationAutocomplete(input) {
  window.autoCompleteSearchBar = input;
  window.initAutoComplete(input);
}
